import { useSearchParams } from "react-router-dom";
import { useMailerConfigShowQuery } from "@/admin/entities/mailerConfigs";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useMailerConfigsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useMailerConfigShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
